// Small shared formatting helpers for tooltip/details/legend HTML strings.

export function escapeHtml(s: string): string {
  const map: Record<string, string> = { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" };
  return s.replace(/[&<>"']/g, (c) => map[c]);
}

/** "18.3 °C" or "no data". */
export function formatValue(v: number | null, decimals: number, unit: string): string {
  return v === null ? "no data" : `${v.toFixed(decimals)} ${unit}`;
}

/** "+2.1 °C" / "-1.4 °C" / "no data" — differences always carry an explicit sign. */
export function formatDiff(v: number | null, decimals: number, unit: string): string {
  if (v === null) return "no data";
  const sign = v > 0 ? "+" : "";
  return `${sign}${v.toFixed(decimals)} ${unit}`;
}
